import React from 'react';
import {createRoot} from 'react-dom/client';

import {assertIsNotNullish} from '@br/idm-components';

import {AppRoot} from '../components/AppRoot';
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';
import BasePage from '../components/templates/BasePage/BasePage';
import Legal from '../page/Legal';

const container = document.querySelector('main');
assertIsNotNullish(container);

// Find the first element in the document which contains text.
const titleElement = container.querySelector('span:not(:empty):not([style=""])') as HTMLSpanElement;
const title = titleElement.textContent;

// Remove the title and get the terms.
titleElement.remove();
const terms = container.innerHTML;

const App = () => (
    <AppRoot>
        <BasePage>
            <ErrorBoundary>
                <Legal
                    title={title}
                    terms={terms}
                />
            </ErrorBoundary>
        </BasePage>
    </AppRoot>
);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(<App />);

// Hidden in legal.html to hide clunky rendering process
// Make visible after render.
container.style.visibility = 'visible';
